;(function () {
  "use strict";

  var NewSequence = function () {
    var $queryForm = $('#new_sequence_search');
    var $responseContainer = $('#response-form-container');
    var $queryInput = $queryForm.find('input[name="query"]');
    var $charCount = $('#char-count');
    var $entryError = $('#sequence-entry-error');
    var lenseVerifyTimer;

    var setGenerating = function (generating) {
      var $button = $queryForm.find('[data-generate-sequence]');

      $queryForm.attr('aria-busy', generating ? 'true' : 'false');
      $button.prop('disabled', generating);

      // Remember the resting label so the button can say what it is doing and
      // then change back, rather than just greying out with no explanation.
      if (generating) {
        if ($button.data('idle-label') === undefined) {
          $button.data('idle-label', $button.val());
        }
        $button.val('Generating…');
      } else if ($button.data('idle-label') !== undefined) {
        $button.val($button.data('idle-label'));
      }

      // Set display outright rather than .toggle(): toggle leans on jQuery
      // guessing a default display for an element the stylesheet hides, which
      // is easy to break by changing that rule. This states the intent.
      $('#search-spinner').css('display', generating ? 'inline-block' : 'none');
    };

    var showEntryError = function (message) {
      $entryError.text(message).prop('hidden', false);
    };

    var clearEntryError = function () {
      $entryError.text('').prop('hidden', true);
    };

    var updateCharCount = function () {
      var remaining = 255 - $queryInput.val().length;
      $charCount.text(remaining).toggleClass('is-limit', remaining === 0);
    };

    var bindLenseValidation = function ($form) {
      var $lenseInput = $form.find('#sequence_sequence_lense');
      var $textEntry = $form.find('#sequence_sequence_text');
      var $notice = $form.find('.notice');
      var $saveButton = $form.find('[data-save-sequence]');

      $lenseInput.off('.newSequence').on('input.newSequence', function () {
        clearTimeout(lenseVerifyTimer);
        var lenseValue = $lenseInput.val().trim();

        $notice.text('').removeClass('green red');
        $form.data('valid', true);

        if (lenseValue === '') {
          $('#verify-lense-spinner').css('display', 'none');
          $saveButton.prop('disabled', false);
          return;
        }

        $('#verify-lense-spinner').css('display', 'block');
        $saveButton.prop('disabled', true);

        lenseVerifyTimer = setTimeout(function () {
          var query = $textEntry.val() + '0lensetext=' + lenseValue;

          $.ajax({
            type: 'get',
            url: $form.data('verify-url'),
            data: {query: query},
            dataType: 'json'
          }).done(function (response) {
            var valid = response.verification === true;
            $form.data('valid', valid);
            $notice.text(response.message).addClass(valid ? 'green' : 'red');
          }).fail(function () {
            $form.data('valid', false);
            $notice.text('The lense could not be verified. Please try again.').addClass('red');
          }).always(function () {
            $('#verify-lense-spinner').css('display', 'none');
            $saveButton.prop('disabled', false);
          });
        }, 500);
      });
    };

    // `reportMissing` is false on the initial page load: /v2/sequences/new starts
    // with an empty container by design (nothing is generated yet), and treating
    // that as a failure greeted every visitor with an error banner. Only a form
    // we just fetched and failed to find is worth reporting.
    var bindResponseForm = function (reportMissing) {
      var $form = $responseContainer.find('#response-form');
      if ($form.length !== 1) {
        if (reportMissing) {
          showEntryError('The generated entry could not be displayed. Please try again.');
        }
        return;
      }

      bindLenseValidation($form);
      $form.off('submit.newSequence').on('submit.newSequence', function (event) {
        if ($form.data('valid') === false) {
          event.preventDefault();
          $form.find('.sequence-entry-save-status').text('Resolve the lense validation before saving.');
          $form.find('#sequence_sequence_lense').trigger('focus');
          return;
        }

        $form.find('[data-save-sequence]').prop('disabled', true).val('Saving...');
        $form.find('.sequence-entry-save-status').text('Saving entry...');
      });
    };

    var fetchSequenceForm = function () {
      var query = $queryInput.val().trim();
      if (query === '') {
        showEntryError('Enter text before generating the sequence.');
        $queryInput.trigger('focus');
        return;
      }

      clearEntryError();
      setGenerating(true);

      $.ajax({
        type: 'get',
        url: $queryForm.attr('action'),
        data: {query: query, sequence_id: $queryForm.data('sequence-id') || null},
        dataType: 'html'
      }).done(function (responseHtml) {
        $responseContainer.html(responseHtml);
        // The freshly inserted form carries `is-entering`, which runs the
        // reveal keyframes in _sequences.scss. The class comes off once the
        // LAST piece has landed — animationend bubbles, and the form's own
        // animation finishes before the staggered rows, so removing it on the
        // first event would cut the tail of the sequence short.
        var $enteringForm = $responseContainer.find('.sequence-entry-form').addClass('is-entering');
        $enteringForm.on('animationend.sequenceEnter', function (event) {
          if (!$(event.target).is('.sequence-entry-details')) return;
          $enteringForm.off('animationend.sequenceEnter').removeClass('is-entering');
        });
        bindResponseForm(true);
      }).fail(function () {
        $responseContainer.empty();
        showEntryError('The sequence could not be generated. Please try again.');
      }).always(function () {
        setGenerating(false);
      });
    };

    this.configureForm = function () {
      if ($queryForm.length !== 1) return;

      updateCharCount();
      $queryInput.on('input.newSequence', updateCharCount);
      $queryForm.on('submit.newSequence', function (event) {
        event.preventDefault();
        fetchSequenceForm();
      });
      bindResponseForm();
    };
  };

  $(document).ready(function () {
    if ($('body').data('controller') === 'sequences' && ['new', 'edit'].includes($('body').data('action'))) {
      new NewSequence().configureForm();
    }
  });
})();
